import Flickity from "flickity";
require("flickity-fade");
// import { gsap } from "../global/gsap";

const initInsights = (insightsEl) => {
    const mediaCarousel = insightsEl.querySelector(".js-media-carousel");
    const textCarousel = insightsEl.querySelector(".js-text-carousel");

    const mediaOptions = {
        cellAlign: "left",
        wrapAround: false,
        prevNextButtons: false,
        pageDots: false,
        draggable: true,
        setGallerySize: true,
        cellSelector: ".insights__media-slide",
    };

    const mediaFlkty = new Flickity(mediaCarousel, mediaOptions);

    const textOptions = {
        cellAlign: "left",
        wrapAround: false,
        prevNextButtons: false,
        pageDots: true,
        draggable: false,
        fade: true,
        setGallerySize: true,
    };

    const textFlkty = new Flickity(textCarousel, textOptions);

    let isSyncing = false;

    mediaFlkty.on("select", () => {
        if (isSyncing) return;
        isSyncing = true;

        textFlkty.select(mediaFlkty.selectedIndex);
        isSyncing = false;
    });

    textFlkty.on("select", () => {
        if (isSyncing) return;
        isSyncing = true;

        mediaFlkty.select(textFlkty.selectedIndex);
        isSyncing = false;
    });
};

export { initInsights as default };
